var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotVisibleGrey = function SvgNotVisibleGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notVisibleGrey_svg__a)",
    stroke: "#9EA2AA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.97 15.03c-.75.67-1.75 1.09-2.85 1.09-2.35 0-4.25-1.9-4.25-4.25 0-1.09.41-2.1 1.09-2.85",
    strokeWidth: 0.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 7.72c.3-.07.6-.1.92-.1a4.246 4.246 0 0 1 4.15 5.16",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.83 16.89c-1.44.83-3.04 1.4-4.71 1.4-2.85 0-5.48-1.65-7.45-3.38a22.26 22.26 0 0 1-2.3-2.35c-.27-.32-.48-.59-.63-.77.15-.19.36-.45.63-.77.54-.65 1.33-1.5 2.3-2.36.68-.59 1.44-1.18 2.25-1.68",
    strokeWidth: 0.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28 5.81c.91-.33 1.87-.52 2.84-.52 2.85 0 5.48 1.65 7.45 3.37.97.86 1.76 1.71 2.3 2.36.27.32.48.58.63.77-.15.18-.36.45-.63.77-.54.64-1.33 1.5-2.3 2.35-.21.18-.42.36-.64.53",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 5 14 14",
    strokeWidth: 1.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notVisibleGrey_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNotVisibleGrey;